import React from 'react';
import AccessiblyLogo from '../../assets/images/icons/svg/accessiblyLogo';

const ErrorMessage = (props) => {
  return (
    <>
      <div class="wrap text-center">
        <div className="flex justify-center mt-10">
          <AccessiblyLogo/>
        </div>

        <h1 className={`text-2xl mb-2 mt-3 font-semibold`}>Something went wrong!</h1>
        <p className={`text-base mb-1`}>Error message - <span className="font-semibold text-black">{props.message}</span></p>
        <p className={`text-base mb-1`}>Please contact the Accessibly support at <a className="font-semibold text-black" href="mailto:kristiana@accessiblyapp.com">kristiana@accessiblyapp.com</a></p>
      </div>

    </>
  )
}


export default ErrorMessage;
